"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _index = require("../../../utils/styles/index");

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}
/* ++++++++++ --------------- EXPORT : ERROR TEMPLATE : STYLES --------------- ++++++++++ */


var _default = _defineProperty({
  errortemplate: {
    padding: (0, _index.replacePXinStringWithEM)("100px ".concat(_index.theme.spacing.sides)),
    '& #content': {
      display: 'flex',
      flexWrap: 'wrap',
      alignItems: 'center',
      alignContent: 'center',
      justifyContent: 'space-between',
      // ------ message ------ //
      '& .group.name-message': {
        opacity: '0',
        animationName: 'fadeInLeft',
        animationDuration: '.15s',
        animationFillMode: 'forwards',
        animationDelay: '.1s',
        width: (0, _index.pxToEm)(485),
        marginBottom: (0, _index.pxToEm)(40),
        // logo
        '& .logo': {
          width: (0, _index.pxToEm)(222),
          height: (0, _index.pxToEm)(20)
        },
        // code
        '& .code': {
          color: _index.theme.color.primary.medium.swatch,
          fontSize: (0, _index.pxToEm)(106),
          lineHeight: '1',
          margin: "".concat((0, _index.pxToRem)(40), " 0 ").concat((0, _index.pxToRem)(25))
        },
        // title
        '& .title': {},
        // bodycopy
        '& .bodycopy': {
          color: 'rgba(6, 43, 117, .5)'
        }
      },
      // ----- visual ----- //
      '& .group.name-visual': {
        opacity: '0',
        animationName: 'fadeInRight',
        animationDuration: '.15s',
        animationFillMode: 'forwards',
        animationDelay: '.1s'
      }
    }
  }
}, _index.mediaQuery.thinnest, {
  errortemplate: {
    '& #content': {
      justifyContent: 'center',
      '& .group.name-message': {
        textAlign: 'center'
      }
    }
  }
});

exports.default = _default;